<template>
    <div>
        <b-modal
            id="edit-product"
            size="lg modal-xlg"
            title="Edit Product"
            hide-footer
            ref="EditProduct"
            no-close-on-backdrop
            no-close-on-esc>
            <b-container fluid class="px-0">
                <div class="modal-form">
                    <b-row no-gutters>
                        <b-col class="border-top border-right dstore-add-delivery-sidebar bg-white" lg="3">
                            <BasicDetails
                                :values="basic_details"
                                :origin="'edit_product'" />

                            <template v-if="basic_details.product_variation == 'variable'">
                                <Variables :values="product_variables"
                                    @addAttribute="addAttribute"
                                    @addVariation="addVariation"
                                    @generateVariations="generateVariations('edit_product')"
                                    @deleteVariation="deleteVariation"
                                    @deleteAttribute="deleteAttribute"
                                    :origin="'edit_product'" />
                            </template>
                            <AdOns :values="ad_on_items"
                                @addAttributeAdOn="addAttributeAdOn"
                                @addVariationAdOn="addVariationAdOn"
                                @generateVariationsAdOn="generateVariationsAdOn"
                                @addAttributeAdOnEdit="addAttributeAdOnEdit"
                                @addVariationAdOnEdit="addVariationAdOnEdit"
                                @generateVariationsAdOnEdit="generateVariationsAdOnEdit"
                                @deleteVariationAdOn="deleteVariationAdOn"
                                @deleteVariationAdOnEdit="deleteVariationAdOnEdit"
                                @deleteAttributeAdOn="deleteAttributeAdOn"
                                @deleteAttributeAdOnEdit="deleteAttributeAdOnEdit"
                                :origin="'edit_product'" />
                            <ProductImages
                                :values="product_images"
                                :firstAdditionalImage="firstAdditionalImage"
                                :secondAdditionalImage="secondAdditionalImage"
                                @removeImage="removeProductImage"
                                :origin="'edit_product'" />
                        </b-col>
                        <b-col class="border-top p-0" lg="9">
                            <b-row no-gutters class="border-bottom px-4 py-3" style="background-color: #ffffff;">
                                <b-col></b-col>
                                <b-col cols="2">
                                    <b-button
                                        variant="primary"
                                        v-bind:disabled="loading"
                                        block
                                        class="save-button"
                                        @click="saveProduct">
                                        <template v-if="loading">
                                        SAVING PRODUCT
                                        </template>
                                        <template v-else>
                                            SAVE PRODUCT
                                        </template>
                                    </b-button>
                                </b-col>
                            </b-row>
                            <div class="main">
                                <template v-if="basic_details.product_variation === 'simple'">
                                    <SimpleProduct :values="simple_product" :origin="'edit_product'" :payment="payment" />
                                </template>
                                <template v-else>
                                    <ProductVariables
                                        :values="variation_items"
                                        :discount="product_variables.discount"
                                        :origin="'edit_product'"
                                        :sale="product_variables.sale"
                                        @updateDiscountValue="updateDiscountValue"
                                        :variation_names="$parent.variation_names"
                                        :payment="payment"
                                        :basic_details="basic_details" />
                                </template>
                                <template v-if="ad_on_items.length > 0">
                                    <AdOnItems
                                        :generatedAdOns="generatedAdOns"
                                        :values="ad_on_items"
                                        :origin="'edit_product'"
                                        :payment="payment"
                                        @updateDiscountValue="updateDiscountValue" />
                                </template>
                        </div>
                        </b-col>
                    </b-row>
                </div>
            </b-container>
            <template slot="modal-header-close" @click="closeModal">
                <span @click="closeModal">×</span>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapState } from "vuex";

import BasicDetails from "./BasicDetails";
import ProductImages from "./ProductImages";
import SimpleProduct from "./SimpleProduct";
import ProductVariables from "./ProductVariables";
import Variables from "./Variables";
import AdOns from "./AdOns";
import AdOnItems from "./AdOnItems";
import _ from "lodash";

import pvg from "../../../services/product.variance.generator";

function initialProductImages() {
    return [
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false }
    ];
}

export default {
    name: "EditProduct",
    props: [
        "status",
        "basic_details",
        "simple_product",
        "product_variables",
        "variation_items",
        "payment",
        "from_page",
        "ad_ons"
    ],
    components: {
        BasicDetails,
        ProductImages,
        SimpleProduct,
        ProductVariables,
        Variables,
        AdOns,
        AdOnItems
    },
    data() {
        return {
            uuid: null,
            product_images: initialProductImages(),
            firstAdditionalImageUuid: "",
            firstAdditionalImage: "",
            secondAdditionalImageUuid: "",
            secondAdditionalImage: "",
            variation_names: [],
            delete_images: [],
            init_daterange: [],
            ad_on_items: [],
            temporary_ad_on_items: [],
            generatedAdOns: false
        };
    },
    computed: {
        ...mapState("dstoreInventories", [
            "loading",
            "errors",
            "product_data",
            "available_stocks",
            "modal",
            "sale",
            "pagination"
        ])
    },
    methods: {
        closeModal: function() {
            this.setInitialData();
            if (this.from_page == "locations-products") {
                this.$store.commit("estoreLocations/setModal", {
                    type: "edit_product",
                    status: false
                });
                this.$store.commit(
                    "estoreLocations/setEditingFromLocationsPage",
                    false
                );
            } else {
                this.$store.commit("dstoreInventories/setModal", {
                    type: "edit_product",
                    status: false
                });
            }
        },
        saveProduct: async function() {
            let update_images = await this.product_images
                .map(image => {
                    return {
                        action: "create",
                        type: "main",
                        image: image.image
                    };
                })
                .filter(image => image.image !== "")
                .filter(image => image.image.split(":")[0] !== "https");

            if (
                this.firstAdditionalImage.split(":")[0] !== "https" &&
                this.firstAdditionalImage !== ""
            ) {
                if (this.firstAdditionalImageUuid !== "") {
                    update_images.push({
                        uuid: this.firstAdditionalImageUuid,
                        action: "create",
                        image: this.firstAdditionalImage,
                        type: "additional-image-1"
                    });
                } else {
                    update_images.push({
                        action: "create",
                        image: this.firstAdditionalImage,
                        type: "additional-image-1"
                    });
                }
            }

            if (
                this.secondAdditionalImage.split(":")[0] !== "https" &&
                this.secondAdditionalImage !== ""
            ) {
                if (this.secondAdditionalImageUuid !== "") {
                    update_images.push({
                        uuid: this.secondAdditionalImageUuid,
                        action: "create",
                        image: this.secondAdditionalImage,
                        type: "additional-image-2"
                    });
                } else {
                    update_images.push({
                        action: "create",
                        image: this.secondAdditionalImage,
                        type: "additional-image-2"
                    });
                }
            }

            if (this.delete_images.length > 0) {
                this.delete_images.map(image => {
                    return update_images.push(image);
                });
            }

            let check_images = this.product_images
                .map(image => {
                    return image;
                })
                .filter(image => image.image !== "");

            let param = {
                uuid: this.uuid,
                updates: {}
            };

            // let formattedAdOns = [];
            // this.ad_on_items.forEach(attribute => {
            //     let formattedAttribute = {};
            //     formattedAttribute = {
            //         uuid: attribute.uuid,
            //         name: attribute.name,
            //         limit: attribute.limit,
            //         items: attribute.add_ons
            //     };
            //     formattedAdOns.push(formattedAttribute);
            // });

            // param.updates["add_ons"] = formattedAdOns;

            let basic_details = this.basic_details;

            param.updates["name"] = basic_details.name;
            param.updates["description"] = basic_details.description;
            param.updates["category_id"] = basic_details.category_id;

            if (update_images.length > 0 || check_images.length == 0) {
                param.updates["product_images"] = update_images;
            }

            let simple_product = this.simple_product;

            param.updates["on_sale"] = simple_product.on_sale;
            param.updates["visibility"] = simple_product.visibility;
            param.updates["stocks"] = simple_product.stocks;
            param.updates["is_stocks"] = simple_product.is_stocks;
            param.updates["currency"] = simple_product.currency;
            param.updates["price"] = simple_product.price;
            param.updates["sku"] = simple_product.sku;
            param.updates["type"] = "simple";

            if (simple_product.on_sale == true || simple_product == 1) {
                param.updates["sale_type"] = simple_product.sale_type;
                param.updates["sale_value"] = simple_product.sale_value;

                if (
                    this.$parent.isMoment(
                        simple_product.date_range.split(" to ")[0]
                    )
                ) {
                    param.updates["sale_from"] =
                        simple_product.date_range.split(" to ")[0] +
                        " 00:00:00";
                } else {
                    param.updates["sale_from"] =
                        this.$parent.formatDate(
                            simple_product.date_range.split(" to ")[0]
                        ) + " 00:00:00";
                }
                if (
                    this.$parent.isMoment(
                        simple_product.date_range.split(" to ")[1]
                    )
                ) {
                    param.updates["sale_from"] =
                        simple_product.date_range.split(" to ")[1] +
                        " 23:59:59";
                } else {
                    param.updates["sale_to"] =
                        this.$parent.formatDate(
                            simple_product.date_range.split(" to ")[1]
                        ) + " 23:59:59";
                }
            }

            console.log(param);

            // if (this.from_page == "locations-products") {
            //     param.branch_uuid = this.branchInfo.uuid;
            // }

            await this.$store
                .dispatch("dstoreInventories/updateSimpleProduct", param)
                .then(() => {
                    if (this.errors == null) {
                        this.closeModal();
                        this.$store.dispatch("dstoreInventories/getProducts", {
                            page: this.pagination.currentPage,
                            payload: {
                                filters: {
                                    paired_key: "all",
                                    keyword: "",
                                    column: "all"
                                }
                            }
                        });
                    }
                });
        },
        removeProductImage: async function(image) {
            this.product_images.splice(image.index, 1);
            this.product_images.push({
                image: "",
                active: false
            });

            let is_images_empty = await this.product_images
                .map(image => {
                    return image;
                })
                .filter(image => image.image == "");

            this.delete_images.push({
                action: "delete",
                uuid: image.uuid
            });

            if (is_images_empty.length == 10) {
                await this.$store.commit(
                    "dstoreInventories/setActiveImage",
                    null
                );
            } else {
                await this.$store.commit("dstoreInventories/setActiveImage", 0);
            }
        },
        addAttribute: function(attribute) {
            this.$parent.addAttribute(attribute);
        },
        addVariation: function(index) {
            this.$parent.addVariation(index);
        },
        generateVariations: function(origin) {
            this.$parent.generateVariations(origin);
        },
        deleteAttribute: function(index) {
            this.$parent.deleteAttribute(index);
        },
        deleteVariation: function(param) {
            this.$parent.deleteVariation(param);
        },
        addAttributeAdOn: function(attribute) {
            this.$parent.addAttributeAdOn(attribute);
        },
        addAttributeAdOnEdit: function(attribute) {
            this.ad_on_items.push(attribute);
            this.generatedAdOns = false;
        },
        addVariationAdOn: function(index) {
            this.$parent.addVariationAdOn(index);
        },
        addVariationAdOnEdit: function(index) {
            this.ad_on_items[index]["add_ons"].push({
                uuid: null,
                name: "",
                currency: "PHP",
                price: "1",
                sku: null,
                visibility: 1,
                free: 0
            });
            this.generatedAdOns = false;
        },
        generateVariationsAdOn: function() {
            this.$parent.generateVariationsAdOn();
        },
        generateVariationsAdOnEdit: function() {
            let known_variants = new Set();
            this.ad_on_items.map(product => {
                product.add_ons = product.add_ons.filter(
                    item =>
                        !known_variants.has(item.name.toLowerCase()) &&
                        known_variants.add(item.name.toLowerCase()) &&
                        item.name != ""
                );
                return product;
            });

            this.ad_on_items = this.ad_on_items.filter(
                product => product.name != ""
            );

            this.generatedAdOns = true;
        },
        deleteAttributeAdOn: function(index) {
            this.$parent.deleteAttributeAdOn(index);
        },
        deleteAttributeAdOnEdit: function(index) {
            this.ad_on_items.splice(index, 1);
        },
        deleteVariationAdOn: function(param) {
            this.$parent.deleteVariationAdOn(param);
        },
        deleteVariationAdOnEdit: function(param) {
            this.ad_on_items[param.attribute].add_ons.splice(
                param.variation,
                1
            );
        },
        updateDiscountValue: function(value) {
            this.$parent.updateDiscountValue(value);
        },
        setInitialData: function() {
            this.$parent.setBasicDetailsInit();
            this.$parent.setSimpleProductInit();
            this.$parent.setProductVariablesInit();
            this.$parent.setVariationItemsInit();
            this.product_images = initialProductImages();
            this.firstAdditionalImage = "";
            this.secondAdditionalImage = "";
        }
    },
    watch: {
        status: function(status) {
            if (status === true) {
                this.$refs.EditProduct.show();
                this.$store.commit("dstoreInventories/setActiveImage", null);
                this.$store.commit("dstoreInventories/errors", null);
            } else {
                this.$refs.EditProduct.hide();
            }
        },

        product_data: function(data) {
            this.$store.commit("dstoreInventories/errors", null);
            // Simple Product
            if (data.type == "simple") {
                let product_details = data;

                this.basic_details.name = product_details.name;
                this.basic_details.description = product_details.description;
                this.basic_details.product_variation = product_details.type;
                this.basic_details.category_id =
                    product_details.category != null
                        ? product_details.category.id
                        : null;

                product_details.images
                    .filter(image => image.type === 'main')
                    .map((image, index) => {
                        this.product_images[index].image = image.name;
                        this.product_images[index]["uuid"] = image.uuid;
                    });

                const primaryAdditionalImg = product_details.images.find(image => image.type === 'additional-image-1');
                if (primaryAdditionalImg) {
                    this.firstAdditionalImageUuid = primaryAdditionalImg.uuid;
                    this.firstAdditionalImage = primaryAdditionalImg.name;
                }

                const secondaryAdditonalImg = product_details.images.find(image => image.type === 'additional-image-2');
                if (secondaryAdditonalImg) {
                    this.secondAdditionalImageUuid = secondaryAdditonalImg.uuid;
                    this.secondAdditionalImage = secondaryAdditonalImg.name;
                }                

                this.ad_on_items = product_details.add_ons_category;
            }

            this.uuid = data.uuid;

            this.$store.commit("dstoreInventories/setActiveImage", 0);

            if (data.type == "simple") {
                this.simple_product.on_sale = data.on_sale == 1 ? true : false;
                this.simple_product.is_stocks =
                    data.is_stocks == 1 ? true : false;
                this.simple_product.visibility =
                    data.visibility == 1 ? true : false;
                this.simple_product.stocks = this.available_stocks;
                this.simple_product.currency = data.currency;
                this.simple_product.price = Number.parseFloat(
                    data.price
                ).toFixed(2);
                this.simple_product.sku = data.sku;
            }

            if (data.on_sale == 1) {
                this.simple_product.sale_type = data.sale_type;
                this.simple_product.sale_value = Number.parseFloat(
                    data.sale_value
                ).toFixed(2);
            }

            if (data.type == "simple") {
                if (data.images.length == 0) {
                    this.$store.commit(
                        "dstoreInventories/setActiveImage",
                        null
                    );
                } else {
                    this.$store.commit("dstoreInventories/setActiveImage", 0);
                }
                this.simple_product.date_range =
                    data.date_range !== null && data.on_sale == 1
                        ? data.sale_from.split(" ")[0] +
                          " to " +
                          data.sale_to.split(" ")[0]
                        : this.$parent.formatDate(new Date()) +
                          " to " +
                          this.$parent.formatDate(new Date());
                this.init_daterange = [data.sale_from, data.sale_to];
            } else {
                if (data.images.length == 0) {
                    this.$store.commit(
                        "dstoreInventories/setActiveImage",
                        null
                    );
                } else {
                    this.$store.commit("dstoreInventories/setActiveImage", 0);
                }
            }
        },
        available_stocks: function(data) {
            // console.log(data);
            this.simple_product.stocks = data;
            // console.log(this.simple_product);
        },
        "modal.croppa.base64": function(base64) {
            // console.log(this.modal.croppa);
            if (base64 !== null && this.modal.croppa.additionalImage == null) {
                let empty_images = this.product_images
                    .map((image, index) => {
                        return {
                            image: image.image,
                            index: index
                        };
                    })
                    .filter(image => image.image == "");

                let get_index = empty_images[0].index;

                if (this.product_images[0] !== "") {
                    this.$store.commit("dstoreInventories/setActiveImage", 0);
                }

                this.product_images[get_index].image = base64;
            } else {
                if (this.modal.croppa.additionalImage == "first") {
                    this.firstAdditionalImage = base64;
                    // console.log(this.firstAdditionalImage);
                } else if (this.modal.croppa.additionalImage == "second") {
                    this.secondAdditionalImage = base64;
                    // console.log(this.secondAdditionalImage);
                }
            }
        }
    }
};
</script>
